import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Menu as MenuIcon } from 'lucide-react';

export default function SortableProduct({ product, children }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: product.id });
  
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  
  return (
    <div ref={setNodeRef} style={style} className="flex items-start gap-2">
      <button {...attributes} {...listeners} className="cursor-move p-2 hover:bg-gray-100 rounded mt-2" type="button">
        <MenuIcon className="w-4 h-4 text-gray-400" />
      </button>
      <div className="flex-1">{children}</div>
    </div>
  );
}
